/* import __COLOCATED_TEMPLATE__ from './svg-widget.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import Utils from '../../utils/utils';
import Constants from '../../utils/constants';
import PrettyNum from '../../utils/pretty-num-wrapper';

export default class SvgWidget extends Component {
    tagName = '';

    location = null;
    replacements = {};

    @computed('location', 'replacements.[]', 'hiddenGroups.[]', 'tabLastUpdateDate') get lastUpdateDate() {
        return new Date();
    }

    @action handleSvgRender(element) {
        let svgElement = element.querySelector('svg'),
            modifyElement = (elementToModify, textToReplace, replacement, qaAttrValue) => {
                if (elementToModify) {
                    elementToModify.innerHTML = elementToModify.innerHTML.replace(textToReplace, replacement);
                    if (qaAttrValue)
                        elementToModify.setAttribute(
                            Constants.QA_ATTR_NAME,
                            `${Constants.QA_ATTR_PREFIX}_ckt_${qaAttrValue}_val`,
                        );
                }
            };

        if (svgElement) {
            Object.keys(this.replacements).forEach((key) => {
                let config = this.replacements[key],
                    modelValue = this.get(`model.${config.reference}`),
                    elementsToModify = [];

                if (!config.link) {
                    let replacementValue = Utils.isNumeric(modelValue) ? PrettyNum.eng3(modelValue) : modelValue;
                    if (config.calculate) {
                        replacementValue = PrettyNum.eng3(config.calculate(modelValue));
                    }
                    elementsToModify = Object.values(svgElement.querySelectorAll('tspan')).filter((element) =>
                        element.innerHTML.includes(key),
                    );
                    elementsToModify.push(
                        ...Object.values(svgElement.querySelectorAll('text')).filter((element) =>
                            element.innerHTML.includes(key),
                        ),
                    );
                    elementsToModify.forEach((elementToModify) =>
                        modifyElement(elementToModify, key, replacementValue, config.qaAttrValue || config.reference),
                    );
                } else {
                    let datasheet = this.get(`model.${config.link}`),
                        linkHTML = `<a href="${datasheet}" target="_blank">${modelValue}</a>`;

                    elementsToModify = Object.values(svgElement.querySelectorAll('text')).filter(
                        (element) => element.innerHTML === key,
                    );
                    elementsToModify.forEach((elementToModify) =>
                        modifyElement(elementToModify, key, linkHTML, config.qaAttrValue || config.reference),
                    );
                }
            });

            (this.hiddenGroups || [])
                .filter((hiddenGroup) => hiddenGroup.meetsRequirements(this.model))
                .forEach((hiddenGroup) => {
                    let hiddenElement = document.querySelector(`#${hiddenGroup.key}`);
                    /**
                     * NOTE: Anything that modifies the css instead of the element itself will
                     * not be reflected in the download.
                     */
                    if (hiddenElement) hiddenElement.style.display = 'none'; //hiddenElement.classList.add('hidden');
                });

            svgElement.setAttribute(Constants.QA_ATTR_NAME, `${Constants.QA_ATTR_PREFIX}_ckt`);
        }
    }
}
